import { ErrorIcon } from "~/src/components/Icons/Icons";

export const CounterWithLabel = ({
  label,
  count,
  hasError = false,
}: {
  label: string;
  count?: number;
  hasError?: boolean;
}): JSX.Element => {
  return (
    <>
      {!!count && (
        <dl className="flex grow text-base justify-between ml-4 py-4.5">
          <dt className="text-lg">{label}</dt>
          <dd className="flex mr-16">
            {hasError && (
              <div className="w-16 items-center flex justify-center">
                <ErrorIcon />
              </div>
            )}
            <span className="text-2xl font-bold">{count}</span>
          </dd>
        </dl>
      )}
    </>
  );
};
